import { decodeAsync } from '@msgpack/msgpack';

export interface ServerFileEntry {
  id: number | null;
  rp: string;
  fmo: string | null;
}

export enum PendingFileStatus {
  WAITING_FOR_FILE = 'waiting_for_file',
  UPLOADING = 'uploading'
}

export interface ServerPendingFileEntry extends ServerFileEntry {
  st: PendingFileStatus | string;
}

export interface ServerStateResponse {
  full_path: string;
  existing_files: ServerFileEntry[];
  pending_files: ServerPendingFileEntry[];
}

export interface SessionCreateResponse {
  session: Record<string, any>;
  files: Array<{ id: number; rp: string }>;
}

export async function decodeBinaryResponse<T = unknown>(blob: Blob): Promise<T> {
  const header = new Uint8Array(await blob.slice(0, 2).arrayBuffer());
  const isGzipped = header[0] === 0x1f && header[1] === 0x8b;

  const stream = isGzipped
    ? blob.stream().pipeThrough(new DecompressionStream('gzip'))
    : blob.stream();

  return decodeAsync(stream) as Promise<T>;
}
